var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechRightVue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2167_26570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.19847 33.499L7.19713 33.4884L7.1958 33.4844L7.19847 33.499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00122 7.92969L20.0012 32.0785L34.0012 7.92969H28.4012L20.0012 22.4185L11.5312 7.92969H6.00122Z",
    fill: "#41B883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5312 7.92969L20.0012 22.4885L28.4012 7.92969H23.2212L20.0012 13.5285L16.7112 7.92969H11.5312Z",
    fill: "#35495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5312 7.92969H6.00122L20.0012 32.0785V22.4885L11.5312 7.92969Z",
    fill: "#39A072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7113 7.92969H11.5312L20.0013 22.4885V13.5285L16.7113 7.92969Z",
    fill: "#2E4052"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2167_26570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(6.00122 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechRightVue);
export default __webpack_public_path__ + "static/media/tech-right-vue.25a9d4fa62bceec8a9a86739ede6907b.svg";
export { ForwardRef as ReactComponent };